import { UserPackage } from '../../package/package.type';
import { MyListingItem, MyListingRequest } from './my-listings.type';

export const getMyListings = async (params: MyListingRequest) => {
  return apiClient().get<MyListingItem[]>('/listing/my-listings', {
    params: {
      ...params,
      make: params.make === '-' ? '' : params.make,
      model: params.model === '-' ? '' : params.model,
      status: params.status === '-' ? '' : params.status,
    },
  });
};

export const getUserPackage = async () => {
  return apiClient().get<UserPackage[]>('/listing/user-package');
};

export const markAsSold = async (data: string) => {
  return apiClient().post('/listing/mark-as-sold', data, { headers: { 'Content-Type': 'application/json' } });
};

export const hideListing = async (data: string) => {
  return apiClient().post('/listing/hiden', data, { headers: { 'Content-Type': 'application/json' } });
};

export const publishCar = async (data: string) => {
  return apiClient().post('/listing/publish-car', data, { headers: { 'Content-Type': 'application/json' } });
};

export const deleteListing = async (data: string) => {
  return apiClient().delete('/listing/delete', { 
    data, 
    headers: { 'Content-Type': 'application/json' } 
  });
};